<script>
    import { fade } from 'svelte/transition';
import Warning from '../icons/Warning.svelte';
    import { updateApp } from '../store';

    //todo add translations
    let language = "en";
    let no = "Not Now";
    let yes = "UPDATE";
    let header = 'Update Available';
    language = getLang(navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage);

    let reloadText = 'A new version of this App is available.';
    switch (language) {
        case 'es':
            reloadText = 'Una nueva versión de esta aplicación está disponible.';
            yes = 'ACTUALIZAR';
            no = 'Ahora no';
            header = 'Actualización disponible'
            break;
        case 'fr':
            reloadText = 'Une nouvelle version de cette application est disponible. ';
            yes = 'METTRE À JOUR';
            no = 'Pas maintenant';
            header = 'Mise à jour disponible'
            break;
        case 'pt':
            reloadText = 'Está disponível uma nova versão deste aplicativo.';
            yes = 'ATUALIZAR';
            no = 'Agora não';
            header = 'Atualização disponível'
            break;
        case 'ru':
            reloadText = 'Доступна новая версия этого приложения. ';
            yes = 'ОБНОВИТЬ';
            no = 'Не сейчас';
            header = 'Доступно обновление'
            break;
        case 'zh':
        case 'cn':
            reloadText = '此应用程序的新版本可用。';
            yes = '更新';
            no = '现在不要';
            header = '有可用更新'
            break;
        case 'id':
            reloadText = 'Versi baru dari App ini tersedia.';
            yes = 'MEMPERBARUI';
            no = 'Tidak sekarang';
            header = 'Pembaruan tersedia'
            break;
        case 'it':
            reloadText = 'È disponibile una nuova versione di questa applicazione. ';
            yes = 'AGGIORNARE';
            no = 'Non adesso';
            header = 'Aggiornamento disponibile'
            break;
        case 'de':
            reloadText = 'Eine neue Version dieser App ist verfügbar. ';
            yes = 'AKTUALISIEREN';
            no = 'Nicht jetzt';
            header = 'Update verfügbar'
            break;
        case 'jp':
            reloadText = 'このアプリの新しいバージョンが利用可能です。';
            yes = '更新';
            no = '今はやめろ';
            header = '利用可能なアップデート'
            break;
        default:
            reloadText = 'A new version of this App is available.';
    }
</script>

<div class="modal" transition:fade>
    <div id="notify-view">
        <div id="notify-content" class="model-content">
            <h3> {header}</h3>
            <p>{reloadText}</p>
            <div class= "notify-button user-color-background yes" on:click={()=>window.location.reload()}>{yes}</div>
            <div class="notify-text-button close" on:click={()=>updateApp.set(false)}>{no}</div>
        </div>
    </div>
</div>

<style>
    .modal{
        position:absolute;
        top: 0;
        left:0;
        min-width: 100%;
        min-height: 100%;
        z-index: 9999;
        background: rgba(0,0,0,.5);
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
    }
    .model-content{
        max-width: 600px;
        background-color: #fff;
        min-height: 210px;
        border-radius: 12px;
        width:calc(100% - 40px);
        margin: 20px;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        flex-flow: row;
        flex-wrap: wrap;
    }

    .model-content p{
        min-width: 100%;
        text-align: center;
        margin-top: 5px;
    }
    .notify-button {
        color: #fff;
        border-radius: 12px;
        min-width: 100px;
        padding: 15px;
        margin: 5px;
        text-align: center;
        display: block;
        width: 80%;
        cursor: pointer;
        font-weight: bold;
        -webkit-tap-highlight-color: transparent;
    }
    .notify-text-button{
        font-weight: bold;
        color:gray;
        width:100%;
        text-align: center;
        cursor: pointer;
        margin-top: 10px;
        text-transform: uppercase;
    }
    h3{
        margin-bottom: 0;
    }
</style>